"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserDto = instanceOfUserDto;
exports.UserDtoFromJSON = UserDtoFromJSON;
exports.UserDtoFromJSONTyped = UserDtoFromJSONTyped;
exports.UserDtoToJSON = UserDtoToJSON;
exports.UserDtoToJSONTyped = UserDtoToJSONTyped;
/**
 * Check if a given object implements the UserDto interface.
 */
function instanceOfUserDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('fullName' in value) || value['fullName'] === undefined)
        return false;
    if (!('authProviderId' in value) || value['authProviderId'] === undefined)
        return false;
    return true;
}
function UserDtoFromJSON(json) {
    return UserDtoFromJSONTyped(json, false);
}
function UserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'fullName': json['fullName'],
        'authProviderId': json['authProviderId'],
    };
}
function UserDtoToJSON(json) {
    return UserDtoToJSONTyped(json, false);
}
function UserDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
        'fullName': value['fullName'],
        'authProviderId': value['authProviderId'],
    };
}
